const ICON_BADGE_ICON_SIZE_MAP = {
  sm: 'xs',
  md: 'sm',
  lg: 'md',
  xl: 'md'
};

export { ICON_BADGE_ICON_SIZE_MAP };
